import { useTranslation } from 'react-i18next';

import gql from 'graphql-tag';
import { keyBy } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';

import ActionButton from 'components/action/ActionButton';

import {
	useCreateCommentMutation,
	useUpdateCommentMutation,
	useDeleteCommentMutation
} from 'graph/dist/generated';
import CommentsList from '../CommentsList';
import CommentModal from 'components/Modal/CommentModal';
import { getFragmentFields } from 'utils/graphql';

import { useGetCommentsQuery } from 'graph/queries';
import Loader from 'components/Loading/Loader';
import { Flex } from 'antd';

export const CommentsTab = (props: any) => {
	const { t } = useTranslation();

	const [createComment] = useCreateCommentMutation();
	const [updateComment] = useUpdateCommentMutation();
	const [deleteComment] = useDeleteCommentMutation();

	const { data, loading, error, refetch } = useGetCommentsQuery(props.projectId, props.type, props.selection.id);

	console.log('data', data, "loading", loading, "error", error);

	const comments = data?.getComments || [];
	const indexedComments = keyBy(comments, 'id');

	// Create
	const handleCreateComment = async (
		objectId: string
	) => {
		props.pushModal(
			<CommentModal
				onSave={async (values) => {
					console.log('onChange test', values);

					let variables = {
						projectId: props.projectId,
						objectType: props.type,
						objectId,
						description: values.description,
						commentedAt: values.commentedAt
					};
					let result = await createComment({
						variables,
						update(cache, { data: { createComment } }) {
							cache.modify({
								id: `Stakeholder:${objectId}`,
								fields: {
									comments(
										existingStakeholdersLinksRef,
										{ readField }
									) {
										const newComment =
											cache.writeFragment({
												id:
													'Comment:' +
													createComment.id,
												data: createComment,
												fragment: gql`
													fragment StakeholderFragment on Stakeholder {
														${getFragmentFields(variables)}
													}
												`
											});
										return [
											...existingStakeholdersLinksRef,
											newComment
										];
									}
								}
							});
						},

						optimisticResponse: {
							createComment: {
								__typename: 'Comment',
								id: 'temp-id',
								createdAt: new Date().toISOString(),
								...variables
							}
						}
					});

					refetch();
				}}
			></CommentModal>
		);
	};

	// Create
	const handleEditComment = async (
		stakeholderId: string,
		id: string
	) => {
		console.log('Comment', indexedComments[id]);

		props.pushModal(
			<CommentModal
				values={indexedComments[id] || {}}
				onDelete={() =>
					handleDeleteComment(stakeholderId, id)
				}
				onSave={async (values) => {
					console.log('onChange test', values);

					let variables = {
						id,
						description: values.description,
						commentedAt: values.commentedAt.format('YYYY-MM-DD')
					};
					let result = await updateComment({
						variables,
						update(cache) {
							cache.modify({
								id: `Comment:${id}`,
								fields: {
									description() {
										return variables.description;
									},
									commentedAt() {
										return variables.commentedAt;
									}
								}
							});
						},

						optimisticResponse: {
							updateComment: true
						}
					});
				}}
			></CommentModal>
		);
	};

	// Delete
	const handleDeleteComment = async (
		stakeholderId: string,
		id: string
	) => {
		console.log('handleDeleteComment', id);

		await deleteComment({
			variables: {
				id
			},

			update(cache, { data: { deleteComment } }) {
				cache.modify({
					id: `Stakeholder:${stakeholderId}`,
					fields: {
						comments(existingCommentsRef, { readField }) {
							return existingCommentsRef.filter(
								(ref: string) => id !== readField('id', ref)
							);
						}
					}
				});
			},

			optimisticResponse: {
				deleteComment: true
			}
		});
	};

	if (loading) {
		return <Flex justify="center" align="center"><Loader></Loader></Flex>;
	}

	//onDelete={(id: string) => handleDeleteComment(props.selection.id, id)}
	return (
		<>
			<Flex vertical className="pt-1">
				{props &&
					(!comments ||
						comments
							.length == 0) && (
						<div style={{ color: 'var(--ant-color-text-tertiary)' }}>
							{t('models.item_comment.no_x')}
						</div>
					)}

				<CommentsList
					onEdit={(id: string) =>
						handleEditComment(props.selection.id, id)
					}
					items={comments}
				></CommentsList>

				{
					<div className="Actions mt-2 ml-auto mr-auto">
						<ActionButton
							className="small"
							tooltip={t('models.item.actions.edit')}
							onClick={() =>
								handleCreateComment(
									props.selection.id
								)
							}
						>
							<FontAwesomeIcon icon={faPlus} />
						</ActionButton>
					</div>
				}
			</Flex>
		</>
	);
};

export default CommentsTab;
